<template>
<div id="main-container" v-if="isVisible">
    <div class="form-container">
        <div class="form-fields">
            <div class="upload-title">Upload kol cover</div>
            <p>Use the mp3 button to upload song from your <br />computer, mobile phone or tablet.</p>
            <p>Once you’ve submitted your song it will be pending until Inherit the Music approves your upload. Check back daily to see if your song got published to the virtual studio!</p>
            <p>Kings of Leon cover uploads only. All covers will be reviewed prior to posting to ensure it complies with the KOL Cover Exhibition and Gold Pacific Virtual Studios
              <router-link class="terms-of-use" target="_blank" to="/terms-conditions#terms">
                <span class="router-link-color">terms of service</span>
              </router-link>.
            </p>
            <div id="img-uploader-top">
                <div v-if="downloadImageURL && !uploadingImage" class="select-img-cont">
                    <div class="d-flex flex-column">
                        <v-img :src="downloadImageURL" class="uploaded-img" width="183px" height="183px"/>
                        <div class="change-photo-link" @click="selectCoverImage">Change Photo</div>
                    </div>
                </div>
                <div v-if="uploadingImage" class="select-img-cont">
                    <div class="d-flex flex-column ul-image-cont">
                        <v-progress-circular v-if="uploadingImage && !uploadImageEnd" :size="100" :width="5" :rotate="360" :value="progressUpload" color="#18c684">
                            {{ progressUpload }}%
                        </v-progress-circular>
                    </div>
                </div>
                <div v-if="!downloadImageURL && !uploadingImage" class="select-img-cont">
                    <div @click="selectCoverImage" class="d-flex flex-column ul-image-cont">
                        <img :src="require('../assets/graphic/camera-2.svg')" class="ul-icon-image" width="32px" alt="camera"/>
                        <p class="upload-cover-art-text">add cover art</p>
                    </div>
                </div>
            </div>
            <v-text-field dark v-model="name" color="#e1a732" label="Name *" :rules="[rules.required]"></v-text-field>
            <v-text-field dark v-model="age" color="#e1a732" label="Age *" :rules="[rules.required, rules.age]"></v-text-field>
            <v-text-field dark v-model="email" color="#e1a732" label="Email *" :rules="[rules.required, rules.emailLength, rules.validEmail]"></v-text-field>
            <v-text-field dark v-model="songName" color="#e1a732" label="Song Name *" :rules="[rules.required]"></v-text-field>
            <div class="upload-gd-container">
             <OrganizationDropdown
                :org-open="orgOpen"
                :on-click-org="onSelectOrg"
                :hide-all="true"
             />
            </div>
            <p id="upload-notes-header">Notes</p>
            <v-textarea outlined dark color="#e1a732" placeholder="(Optional)" v-model="notes" height="100px"></v-textarea>
            <!-- Terms acceptance checkbox -->
            <v-checkbox dark v-model="termsAccepted" color="#e1a732">
                <template v-slot:label>
                    <div>
                        I accept the
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <a
                                    target="_blank"
                                    :href="`${urlOrigin}/terms-conditions#terms`"
                                    @click.stop
                                    v-on="on"
                                    class="terms-of-use"
                                >
                                  Terms of Service
                                </a>
                            </template>
                            View terms in new window
                        </v-tooltip>,
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                              target="_blank"
                              :href="`${urlOrigin}/end-user-agreement`"
                              @click.stop
                              v-on="on"
                              class="end-user-agreement"
                          >
                             End User License Agreement
                          </a>
                        </template>
                        View End User Agreement in new window
                      </v-tooltip>
                        and verify that I am the proper person to do so
                    </div>
                </template>
            </v-checkbox>
            <div id="upload-btn-cont">
              <button class="upload-mp3-btn" :disabled="!validateForm" @click="selectFile" v-if="!uploadEnd && !uploading">
                upload mp3
              </button>
            </div>
            <p v-if="!this.downloadImageURL && !this.uploadingImage && this.selectFilePressed" id="upload-error-msg">Please upload a cover photo</p>
            <form ref="form">
                <input id="song-file" type="file" name="file" ref="uploadInput" accept="audio/mp3" :multiple="false" @change="detectFiles($event)" />
            </form>
            <form ref="form">
                <input id="cover-img" type="file" name="file" ref="uploadImageInput" accept="image/*" :multiple="false" @change="detectImageFiles($event)" />
            </form>
            <v-progress-circular v-if="uploading && !uploadEnd" :size="100" :width="5" :rotate="360" :value="progressUpload" color="#e1a732">
                {{ progressUpload }}%
            </v-progress-circular>
            <div v-if="uploadEnd">
                <div v-if="downloadURL">
                    <audio controls class="audio-player">
                        <source :src="downloadURL" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>
                    <!-- {{downloadURL}} -->
                    <p @click="selectFile">Upload different Mp3</p>
                </div>
                <div v-else>
                    <p>Preview unavailable</p>
                </div>
                <v-btn class="ma-0" small color="primary" @click="submitName()">
                    SUBMIT
                </v-btn>
            </div>
        </div>
        <div class="upload-img-cont" id="img-uploader-bottom">
            <v-row justify="space-around">
                <div v-if="downloadImageURL && !uploadingImage">
                    <div class="d-flex flex-column">
                        <v-img :src="downloadImageURL" class="uploaded-img" width="215px" height="215px"/>
                        <div class="change-photo-link" @click="selectCoverImage">Change Photo</div>
                    </div>
                </div>
                <div v-if="uploadingImage">
                    <div class="d-flex flex-column ul-image-cont">
                        <v-progress-circular v-if="uploadingImage && !uploadImageEnd" :size="100" :width="5" :rotate="360" :value="progressUpload" color="#e1a732">
                            {{ progressUpload }}%
                        </v-progress-circular>
                    </div>
                </div>
                <div v-if="!downloadImageURL && !uploadingImage" class="select-img-cont">
                    <div @click="selectCoverImage" class="d-flex flex-column ul-image-cont">
                        <img :src="require('../assets/graphic/camera-2.svg')" class="ul-icon-image"  width="32px" alt="camera-icon"/>
                        <p style="margin-top: 10px;">ADD COVER ART</p>
                    </div>
                </div>
            </v-row>
        </div>
        <v-dialog v-model="dialog" persistent dark width="500px;">
            <v-row justify="center">
                <v-card height="250px" max-width="500px">
                    <div class="submitted-modal">
                        <div class="submitted-modal-title">Thank you for your submission to Gold Pacific Virtual Studios. </div>
                        <div class="submitted-modal-text">We look forward to listening to your song! Once reviewed - you will be notified that your song is live on the site!</div>
                        <div class="submitted-modal-btn-cont">
                            <v-btn @click="reloadPage()" color="#e1a732">OK</v-btn>
                        </div>
                    </div>
                </v-card>
            </v-row>
        </v-dialog>
    </div>
</div>
</template>

<script>
import { fs, db } from '@/config/firebaseInit';
import { environment } from '@/constants';
import moment from 'moment';
import OrganizationDropdown from '@/components/OrganizationDropdown';

const placeholderCoverPhoto = require('../assets/image/appicon-1024-x-1024.png');
export default {
    name: "Uploader",
  components: {OrganizationDropdown},
  props: {
        isVisible: {
            type: Boolean,
            default: true
        }
    },
    data: () => {
        return {
            progressUpload: 0,
            orgOpen: false,
            name: '',
            age: '',
            songName: '',
            email: '',
            organization: 'Organization',
            notes: '',
            fileName: '',
            fileListArray: [],
            uploadTask: '',
            uploadImageTask: '',
            dialog: false,
            uploading: false,
            uploadingImage: false,
            uploadEnd: false,
            uploadImageEnd: false,
            downloadURL: false,
            downloadImageURL: null,
            termsAccepted: false,
            audioFileAdded: false,
            imageFileAdded: false,
            uploadReady: false,
            selectFilePressed: false,
            urlOrigin: window.location.origin,
            rules: {
              required: value => !!value || 'Required.',
              age: value => (13 <= parseInt(value) && (parseInt(value) <= 18)) || 'Must be between 13 and 18 years old.',
              emailLength:  value => (value || '').length <= 40 || 'Max 40 characters',
              validEmail: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
              }
            },
        }
    },
    created() {
        this.getTerms('v0.1')
    },
    methods: {
        getWindowContent(index = 3) {
            this.currentWindow = index;
        },
        getPressedSong(song) {
            this.songSelected = true;
            this.song = song;
        },
        reloadPage() {
            this.submission = null;
            this.dialog = false;
            window.location.reload()
        },
        getTerms(version) {
            db.collection('terms').doc(version).get().then(doc => {
                this.terms = doc.data()
            })
        },
        onSelectGenre(genre) {
          this.selectedGenre = genre;
        },
        onSelectOrg (org) {
          this.organization = org;
        },
        submitName() {
            /*eslint no-unused-vars:*/
            // Create a new submission document if there isn't one already
            if (!this.submission) {
                this.submission = db.collection(`${environment}-submissions`).doc();
            }
            // Set or update submission details
            this.submission.set({
                    name: this.name,
                    age: this.age,
                    songName: this.songName,
                    email: this.email,
                    organization: this.organization,
                    fileURL: this.downloadURL,
                    coverURL: this.downloadImageURL || placeholderCoverPhoto,
                    termsAccepted: {
                        ...this.terms,
                        dateAccepted: new Date().toISOString()
                    },
                    approved: false,
                    likes: 0,
                    uploadDate: moment().format(),
                    goldPick: false,
                    notes: this.notes
                })
                .then(() => {
                    this.dialog = true;
                })
                .catch((error) => {
                    console.error("Error writing document: ", error);
                });
        },
        selectFile() {
            if (this.imageFileAdded) {
                this.progressUpload = 0;
                this.uploading = false;
                this.uploadEnd = false;
                this.audioFileAdded = true;
                this.$refs.uploadInput.click();
                this.selectFilePressed = false;
            } else {
                this.selectFilePressed = true;
            }
        },
        selectCoverImage() {
            this.progressUpload = 0;
            this.uploadImageEnd = false;
            this.imageFileAdded = true;
            this.$refs.uploadImageInput.click()
        },
        detectFiles(e) {
            let fileList = e.target.files || e.dataTransfer.files;
            this.fileListArray.push(fileList);
            if (this.audioFileAdded && this.imageFileAdded) {
                Array.from(Array(fileList.length).keys()).map(x => {
                    this.upload(fileList[x])
                })
            }
        },
        detectImageFiles(e) {
            let fileList = e.target.files || e.dataTransfer.files;
            this.fileListArray.push(fileList);
            Array.from(Array(fileList.length).keys()).map(x => {
                this.uploadImage(fileList[x])
            })
        },
        upload(file) {
            this.fileName = file.name
            this.uploading = true
            this.uploadTask = fs.ref(`${environment}-audio/` + file.name).put(file)
        },
        uploadImage(file) {
            this.fileName = file.name;
            this.uploadingImage = true;
            this.uploadImageTask = fs.ref(`${environment}-cover/` + file.name).put(file)
        },
        deleteImage() {
            fs
                .ref('images/' + this.fileName)
                .delete()
                .then(() => {
                    this.uploading = false
                    this.uploadEnd = false
                    this.downloadURL = ''
                })
                .catch((error) => {
                    console.error(`file delete error occured: ${error}`)
                })
            this.$refs.form.reset()
        },
        isBoolean (val) {
            return !!val === val;
        }
    },
    mounted() {
        this.getWindowContent();
    },
    computed: {
        validateFormFields() {
            const validName = this.isBoolean(this.rules.required(this.name));
            const validSongName = this.isBoolean(this.rules.required(this.songName));
            const validEmail = this.isBoolean(this.rules.required(this.email) && this.rules.validEmail(this.email) && this.rules.emailLength(this.email));
            const validAge = this.isBoolean(this.rules.required(this.age) && this.rules.age(this.age));
            return validName && validSongName && validEmail && validAge;
        },
        validateTermsAccepted() {
            return this.termsAccepted
        },
        validateForm() {
            return this.validateFormFields && this.validateTermsAccepted;
        },
    },
    watch: {
        uploadTask: function () {
            this.uploadTask.on('state_changed', sp => {
                    this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
                },
                null,
                () => {
                    this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        this.uploadEnd = true;
                        this.downloadURL = downloadURL;
                        this.$emit('downloadURL', downloadURL)
                    })
                })
        },
        uploadImageTask: function () {
            this.uploadImageTask.on('state_changed', sp => {
                    this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
                },
                null,
                () => {
                    this.uploadImageTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        this.uploadingImage = false;
                        this.uploadImageEnd = true;
                        this.downloadImageURL = downloadURL
                        this.$emit('downloadImageURL', downloadURL)
                    })
                }
            )
        }
    }
}
</script>

<style lang="scss">
#main-container {
    display: flex;
    flex-direction: column;
    color: white;
    background-color: black;
    height: 1200px;
}

.form-container {
    background-color: black;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding: 5% 10%;
}

.form-fields {
    width: 50%;
}

.upload-gd-container {
  margin: 8px 0 16px 0;
}

.org-dropdown-title-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 150px;
  cursor: pointer;
}

.org-dropdown-title {
  font-family: Lato-Bold, sans-serif;
  font-size: 15px;
  text-transform: uppercase;
}

.ul-cont {
    display: flex;
    flex-direction: row;
    margin-bottom: 96px;
}

.columns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.upload-title {
    font-family: SSNicksonFour, serif;
    font-size: 30px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-bottom: 18px;
}

p {
    font-family: Lato-Regular, sans-serif;
    font-size: 15px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
}

.upload-cover-art-text {
  margin-top: 10px;
  text-transform: uppercase;
  font-family: Lato-Bold, sans-serif;
}

.v-label {
  font-family: Lato-Regular, sans-serif;
  font-size: 15px;
  color: white;
}

.progress-bar {
    margin: 10px 0;
}

input[type="file"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
}

#input-usage .v-input__prepend-outer,
#input-usage .v-input__append-outer,
#input-usage .v-input__slot,
#input-usage .v-messages {
    border: 1px dashed rgba(0, 0, 0, .4);
}

.upload-mp3-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 47px;
  border-radius: 24px;
  background-color: #e1a732;
  color: black;
  text-transform: uppercase;
  font-family: Lato-Bold, sans-serif;
  font-size: 15px;
  cursor: pointer;

  &:hover {
    filter: brightness(110%);
  }

  &:disabled {
    background-color: #3d3d3d;
    cursor: default;
    &:hover {
      filter: brightness(100%);
    }
  }
}

.router-link-color.a, a {
  color: #e1a732;
}

.ul-icon-img {
    justify-content: center;
    align-self: center;
    width: 215px;
    height: 215px;
    object-fit: contain;
}

.select-img-cont {
    & :hover {
        opacity: 0.8;
    }
}
.ul-image-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 215px;
    height: 215px;
    background-image: url(../assets/graphic/rectangle.svg);
    cursor: pointer;
    border-radius: 6px;
}

#img-uploader-top {
    display: none;
}

#img-uploader-bottom {
    display: inherit;
}

.uploaded-img {
    border-radius: 6px;
    object-fit: cover;
}

.change-photo-link {
    font-family: 'Lato-Regular', sans-serif;
    margin-top: 10px;
    text-align: center;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.audio-player {
    width: 100%;
    border-radius: 0;
    margin-bottom: 15px;
}

.v-textarea input {
    font-size: 13px;
}
.terms-of-use {
    color: #e1a732;
}

.submitted-modal {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    font-family: 'Lato-Regular', sans-serif;
    padding: 10px 30px;
}

.submitted-modal-title {
    font-size: 30px;
    font-family: 'Lato-Bold', sans-serif;
}

.submitted-modal-text {
    font-size: 14px;
}

.submitted-modal-btn-cont {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

#upload-error-msg {
    color: #eb2352;
    font-family: 'Lato-Regular', sans-serif;
}

@media only screen and (max-width: 640px) {
    #main-container {
        padding: 0;
    }

    .form-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
    }

    .select-img-cont {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #img-uploader-bottom {
        display: none;
    }

    #img-uploader-top {
        display: inherit;
    }

    .upload-title {
        font-size: 24px;
    }

    p {
        font-size: 12px;
    }

    #upload-notes-header {
      font-size: 15px;
    }

    .ul-image-cont {
        width: 183px;
        height: 183px;
    }

    .ul-icon-img {
        width: 183px;
        height: 183px;
    }

    .form-fields {
        width: 100%;
    }

   #upload-btn-cont {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .submitted-modal-title {
        font-size: 20px;
    }
}

@media only screen and (min-width: 641px) and (max-width: 767px) {
    #main-container {
        padding: 0;
    }

    .form-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
    }

    .form-fields {
        width: 100%;
    }

    .select-img-cont {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #img-uploader-bottom {
        display: none;
    }

    #img-uploader-top {
        display: inherit;
    }
}
</style>
